import { createStyles, Grid, Link, ListItem, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import T from 'src/components/content-manager/translator/T';
import HorizontalList from 'src/components/elements/HorizontalList';
import Section from 'src/components/elements/Section';
import CountryLangSelector from 'src/components/page/CountryLangSelector';
import {
    ROUTE_AGB,
    ROUTE_COOKIES,
    ROUTE_IMPRINT,
    ROUTE_PRIVACYPOLICY,
    ROUTE_STORE_LICENSEE_PACKAGES,
    ROUTE_STORE_LICENSOR_PACKAGES,
    ROUTE_STORE_MASTER_LICENSOR_PACKAGES,
    ROUTE_STORE_OP_PACKAGES,
} from 'src/config/routes';
import { useAccount } from 'src/core/hooks/account';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            fontSize: '0.9rem',
            lineHeight: '0.7rem',
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
            },
        },
        hideMobile: {
            [theme.breakpoints.down('sm')]: { display: 'none' },
        },
    })
);

const BottomBar: React.FC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { isLoggedIn, hasPrivilege } = useAccount();

    return (
        <Section
            component="div"
            sx={{ bgcolor: 'grey.800', color: 'common.white' }}
            spacing="compact"
            className={classes.root}>
            <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm="auto">
                    <T k="contact:copyright.value" />
                    &nbsp;-&nbsp;
                    <T k="contact:company.value" />
                </Grid>
                <Grid item xs={12} sm="auto" className={classes.hideMobile}>
                    <CountryLangSelector showLabel="language" />
                </Grid>
                <Grid item xs={12} sm="auto">
                    <HorizontalList dense>
                        {isLoggedIn && hasPrivilege(ROUTE_STORE_LICENSOR_PACKAGES.accessPrivilege!) && (
                            <ListItem>
                                <Link {...ROUTE_STORE_LICENSOR_PACKAGES.componentProps} style={{ color: 'white' }}>
                                    {t(ROUTE_STORE_LICENSOR_PACKAGES.t_name)}
                                </Link>
                            </ListItem>
                        )}
                        {isLoggedIn && hasPrivilege(ROUTE_STORE_LICENSEE_PACKAGES.accessPrivilege!) && (
                            <ListItem>
                                <Link {...ROUTE_STORE_LICENSEE_PACKAGES.componentProps} style={{ color: 'white' }}>
                                    {t(ROUTE_STORE_LICENSEE_PACKAGES.t_name)}
                                </Link>
                            </ListItem>
                        )}
                        {isLoggedIn && hasPrivilege(ROUTE_STORE_OP_PACKAGES.accessPrivilege!) && (
                            <ListItem>
                                <Link {...ROUTE_STORE_OP_PACKAGES.componentProps} style={{ color: 'white' }}>
                                    {t(ROUTE_STORE_OP_PACKAGES.t_name)}
                                </Link>
                            </ListItem>
                        )}
                        {isLoggedIn && hasPrivilege(ROUTE_STORE_MASTER_LICENSOR_PACKAGES.accessPrivilege!) && (
                            <ListItem>
                                <Link
                                    {...ROUTE_STORE_MASTER_LICENSOR_PACKAGES.componentProps}
                                    style={{ color: 'white' }}>
                                    {t(ROUTE_STORE_MASTER_LICENSOR_PACKAGES.t_name)}
                                </Link>
                            </ListItem>
                        )}
                        <ListItem>
                            <Link {...ROUTE_AGB.componentProps} style={{ color: 'white' }}>
                                {t(ROUTE_AGB.t_name)}
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link {...ROUTE_COOKIES.componentProps} style={{ color: 'white' }}>
                                {t(ROUTE_COOKIES.t_name)}
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link {...ROUTE_IMPRINT.componentProps} style={{ color: 'white' }}>
                                {t(ROUTE_IMPRINT.t_name)}
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link {...ROUTE_PRIVACYPOLICY.componentProps} style={{ color: 'white' }}>
                                {t(ROUTE_PRIVACYPOLICY.t_name)}
                            </Link>
                        </ListItem>
                    </HorizontalList>
                </Grid>
            </Grid>
        </Section>
    );
};

export default BottomBar;
